import script from "./BreadCrumbs.vue?vue&type=script&setup=true&lang=ts"
export * from "./BreadCrumbs.vue?vue&type=script&setup=true&lang=ts"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=1d2f3538&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2f3538"]])

export default __exports__